import { compose } from 'recompose'

const enhance = compose()

export default enhance
